import { fetchProducts, productsData } from '~/js/utils/products-and-collections';

const productCard = (productId) => ({
  loading: false,
  error: '',
  productId,

  get shopifyData() {
    if (!this.productId) return null;
    if (this.loading) return null;
    return productsData[this.productId];
  },

  get link() {
    if (!this.shopifyData) return '/';
    return `${window.Shopify.routes.root}products/${this.shopifyData?.handle}`;
  },

  get images() {
    return this.shopifyData?.images || [];
  },

  get description() {
    return this.shopifyData?.description;
  },

  get productReviewCount() {
    const rating = this.shopifyData?.ratingCount?.value;
    const ratingNormalized = Number(rating) || 0;
    return `${ratingNormalized} Review${ratingNormalized === 1 ? '' : 's'}`;
  },

  get qualifiersParsed() {
    const { qualifiers } = this.shopifyData;
    if (!qualifiers?.value) return '';
    try {
      return JSON.parse(qualifiers.value).join(' ');
    } catch (e) {
      return '';
    }
  },

  get title() {
    const { description } = this.shopifyData;
    if (description?.value) return description.value;

    return `${this.qualifiersParsed} ${this.shopifyData?.type.value}`;
  },

  get starRating() {
    return this.shopifyData?.starRatingSnippet;
  },

  get legacyTitle() {
    return this.shopifyData?.title;
  },

  get extractProductId() {
    // Split the string by the '/' character and get the last part
    const gid = this.productId;
    const parts = gid.split('/');
    return parts[parts.length - 1];
  },

  get okendoRating() {
    return 'shopify-' + this.extractProductId;
  },

  get price() {
    return this.shopifyData?.priceRangeFormatted;
  },

  get priceRegular() {
    return this.shopifyData?.compareAtPriceRangeFormatted;
  },

  get hasReducedPrice() {
    const { priceRegular, price } = this;
    return priceRegular && priceRegular !== price;
  },

  get pricingText() {
    return `reduced price: ${this.price}, regular price: ${this.priceRegular}`;
  },

  get pricingExtraText() {
    const { tags } = this.shopifyData;
    const tag = tags.find((tag) => tag.startsWith('Off:'));
    if (!tag) return '';
    const pct = tag.replace('Off:', '');
    return `Extra ${pct}% off on Checkout`;
  },

  get quickBuyTitle() {
    const { shopifyData } = this;

    if (shopifyData.availableForSale) {
      return 'Add To Bag';
    }

    if (shopifyData.tags.includes('Coming Soon') || shopifyData.seasonalCore?.value === 'Core') {
      return 'Notify Me';
    }

    return 'Sold Out';
  },

  get isSoldOut() {
    return this.quickBuyTitle === 'Sold Out';
  },

  get variantsCount() {
    return `${this.shopifyData?.variants.length} variant(s)`;
  },

  init() {
    if (!this.shopifyData) {
      this.loading = true;
      fetchProducts([this.productId])
        .then(() => {
          this.loading = false;
        })
        .catch((e) => {
          this.error = `Error: ${e.message || 'Unknown error'}`;
        });
    }
  },
});

export default productCard;
